'use strict';

angular.module('imagetrend.components')
    .controller('hlpDriversLicenseNumberController', ['$scope', '$timeout', 'Logger', function ($scope, $timeout, Logger) {

        var loggingTimeout = $timeout(function() {
            if ($scope.vm.showDriversLicenseNumber && $scope.recordId && !($scope.ngModel == null || $scope.ngModel == '')) {
                Logger.logAccess($scope.recordId, "Drivers License Number");
            }
        }, 0);

        $scope.getSectionType = function (boxNumber) {
            var result = "password";
            switch(boxNumber) {
                case 1:
                    result = ($scope.vm.showDriversLicenseNumber) ? "text" : "password";
                    break;
            }
            return result;
        }

        $scope.setFields = function (value) {
            if (value != undefined) {
                $scope.vm.boxone = value;
            }
        };

        $scope.validate = function() {
            if ($scope.innerForm !== undefined) {
                if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                    $scope.question.answer.invalid = !isEmpty($scope.innerForm.driversLicenseNumber.$error);
                }
            }
        }
        var validationTimeout = $timeout($scope.validate(), 0);

        $scope.$on('$destroy', function () {
            $timeout.cancel(loggingTimeout);
            $timeout.cancel(validationTimeout);
        });

        $scope.$watch('ngModel', function (ngModel) {
            if (!isUndefined(ngModel) && isUndefined($scope.vm.boxone)) {
                $scope.setFields(ngModel);
            }
        });
    }])
    .directive('hlpDriversLicenseNumber', ['Format', '$timeout', 'Logger', function (Format, $timeout, Logger) {
        return {
            restrict: 'AE',
            scope: {
                name: '@',
                id: '@?',
                showLabel: '@?',
                topLabel: '=?',
                showColon: '=?',
                isRequired: '=?',
                showRequired: '=?',
                isDisabled: '=?',
                change: '&?',
                ngModel: '=',
                question: '=?',
                recordId: '=?',
                label: '@?',
                title: '@?',
                requiredText: '@?',
                instructions: '@?',
                classes: '@?',
                masked: '=?',
                pdf: '=?'
            },
            replace: true,
            require: 'ngModel',
            templateUrl: 'templates/drivers-license-number/drivers-license-number.html',
            link: function (scope, elem, attrs, ctrl) {

                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.masked) { attrs.masked = false }
                $timeout(function () {
                    if (!attrs.requiredText) { scope.requiredText = 'Please enter a ' + Format.label((scope.label || scope.name)) }
                }, 0);
                scope.vm = {};
                scope.vm.showDriversLicenseNumber = !scope.masked;
                scope.vm.boxone = "";

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                    if (scope.question !== undefined && scope.question.answer !== undefined) {
                        scope.question.answer.invalid = !isEmpty(scope.innerForm.driversLicenseNumber.$error);
                    }
                }
                scope.log = function () {
                    if (scope.vm.showDriversLicenseNumber && scope.recordId && !(scope.ngModel == null || scope.ngModel == '')) {
                        Logger.logAccess(scope.recordId, "Drivers License Number");
                    }
                }
                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.validate();
                    scope.submitted = true;
                });
                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            },
            controller: 'hlpDriversLicenseNumberController'
        };
    }])
;